import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Layout from "../Layout";
import Footer from "../../components/Footer";
import CertificateContainer from "../../containers/CertificateContainer";
import { selectLoggedIn } from "../../store/userSlice/userSelectors";
import { createCertainCertificateLink } from "../index";
import SingleCertificateTypeContainer from "../../containers/SingleCertificateTypeContainer";
import GeneralHeader from "../../components/GeneralHeader";

const SingleTypeCertificatePage = ({ type }) => {
  const isLoggedIn = useSelector(selectLoggedIn);

  if (isLoggedIn) {
    return <Navigate to={createCertainCertificateLink(type)} />
  }

  return type === SingleTypeCertificatePage.TYPE.APPROVAL ? (
    <Layout
      header={<GeneralHeader />}
      center={<SingleCertificateTypeContainer type={CertificateContainer.TYPES.APPROVAL} />}
      footer={<Footer />}
    />
  ) : (
    <Layout
      header={<GeneralHeader />}
      center={<SingleCertificateTypeContainer type={CertificateContainer.TYPES.PREMIUM} />}
      footer={<Footer />}
    />
  );
}

SingleTypeCertificatePage.TYPE = {
  PVP: 2,
  APPROVAL: 1
}

export default SingleTypeCertificatePage;